import { render, staticRenderFns } from "./Licenca.vue?vue&type=template&id=37295c6a&scoped=true"
import script from "./Licenca.vue?vue&type=script&lang=js"
export * from "./Licenca.vue?vue&type=script&lang=js"
import style0 from "./Licenca.vue?vue&type=style&index=0&id=37295c6a&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "37295c6a",
  null
  
)

export default component.exports